import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService } from '../../../../../core/services/language.service';
import { BpVerifyBySmsRequest } from '../registration-by-sms.model';
import { UtilsService } from '../../../../../core/services/utils.service';

@Component({
  selector: 'tax-registration-by-sms-form',
  templateUrl: 'registration-by-sms-form.component.html',
  styleUrls: ['registration-by-sms-form.component.sass'],
})

export class RegistrationBySmsFormComponent implements OnInit {
  @Output() continueProcess: EventEmitter<BpVerifyBySmsRequest> = new EventEmitter<BpVerifyBySmsRequest>();

  error: any;
  // @ts-ignore
  loginForm: UntypedFormGroup;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private utilsService: UtilsService,
  ) {}

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      iin: ['', RegistrationBySmsFormComponent.isIndividual],
      phone: [],
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  static isIndividual(inputControl: UntypedFormControl): ValidationErrors | null {
    if (!inputControl.value?.charAt(4)) {
      return null;
    }

    const isIndividual = parseInt(inputControl.value.charAt(4), 10) <= 3;

    return isIndividual
      ? null
      : {
        errorMessage: 'login.sms.iin.error',
        isIndividual: false,
      };
  }

  sendPasswordToUserPhone(): void {
    const verifyBySmsFields: BpVerifyBySmsRequest = {
      IIN: this.loginForm.value.iin,
      phone: this.loginForm.value.phone,
      userLang: this.languageService.currentLanguage.language,
    };
    this.continueProcess.emit(verifyBySmsFields);
  }
}
